module.exports = __webpack_public_path__ + "media/images/users/news-ebe12c77d97ee3600df48400404ae528.png";